import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOption, IOptionsInitialState, IOptionsList } from '@types';

import { initialOptions } from './initialState';

export const optionsSlice = createSlice({
    name: 'options',
    initialState: initialOptions(),
    reducers: {
        setOptions(state: IOptionsInitialState, action: PayloadAction<IOptionsList>) {
            state.optionsList = action.payload;
        },

        setOption(state: IOptionsInitialState, action: PayloadAction<IOption | null>) {
            state.option = action.payload;
        },
    },
});
